import type { JSX } from 'solid-js';

import { useMediaQuery } from '~/utils/media-query';

export interface DialogOverlayProps {
	children: JSX.Element;
}

const DialogOverlay = (props: DialogOverlayProps) => {
	const isMobile = useMediaQuery('(max-width: 767px)');

	return (
		<div
			class={
				`pointer-events-none flex h-full w-full justify-center overflow-y-auto bg-primary/50 dark:bg-hinted/50` +
				(isMobile() ? ` items-end` : ` items-center p-8`)
			}
		>
			<div class="pointer-events-auto contents">{props.children}</div>
		</div>
	);
};

export default DialogOverlay;
